import Image from 'next/image'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import { Skeleton, Box, Typography, Grid, Stack } from '@mui/material'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getActivitiesListServices } from '../../redux/slices/common'

const CategorySlider = ({ router, pageName, title = 'Categories' }) => {
  const dispatch = useDispatch()
  const [isCategoryNotAvailable, setIsCategoryNotAvailable] = useState(false)
  const [services, setServices] = useState([])
  const { activityList } = useSelector(state => state.common)
  const [loader, setLoader] = useState(true)

  useEffect(() => {
    const isActivityPage = pageName === 'activities'
    if (isActivityPage) {
      setLoader(true)
      dispatch(getActivitiesListServices())
    }
    setIsCategoryNotAvailable(!isActivityPage)
  }, [router.asPath])

  useEffect(() => {
    if (activityList && activityList !== undefined) {
      setLoader(false)
      setServices(activityList?.servicesList)
    }
  }, [activityList])

  if (isCategoryNotAvailable) {
    return null
  }

  return loader ? (
    <div className='my-5'>
      <Typography variant='h6' sx={{ marginBottom: 2 }}>
        <Skeleton variant='rectangular' width={200} height={40} />
      </Typography>
      <Grid container spacing={2}>
        {[...Array(4)].map((_, index) => (
          <Grid item xs={3} key={index}>
            <Skeleton variant='rectangular' width='100%' height={180} />
            {/* <Skeleton variant="text" width="60%" sx={{ marginTop: 1 }} /> */}
          </Grid>
        ))}
      </Grid>
    </div>
  ) : (
    <div className='category-slider-container my-5'>
      <h2 className='slider-title'>{title}</h2>
      <hr className='slider-divider' />
      <Swiper
        modules={[Autoplay]}
        slidesPerView={3}
        spaceBetween={60}
        autoplay={{ delay: 3000 }}
        // pagination={{ clickable: true }}
        breakpoints={{
          1024: { slidesPerView: 5 },
          768: { slidesPerView: 3 },
          480: { slidesPerView: 2 },
          320: { slidesPerView: 2 }
        }}
        className='category-slider'
      >
        {services?.map((category, index) => (
          <SwiperSlide key={index} className='category-slide'>
            <Link
              href={`${process.env.NEXTAUTH_URL}/activities/activities?type=${category?.name}`}
              
              key={category.id}
              target='_blank'
            >
              <div className='category-card'>
                <Image
                  width={300}
                  height={300}
                  alt={category.name}
                  src={`${process.env.IMAGE_BASE_URL}/${category?.image}`}
                  className='destination-image'
                  onError={e => (e.currentTarget.src = '/fallback-image.jpg')}
                />
                <div className='category-name'>{category.name}</div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default CategorySlider
